import Icon from '../components/Icon.vue'

Icon.register({"smile":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 176C345.7 176 360 190.3 360 208S345.7 240 328 240 296 225.7 296 208 310.3 176 328 176zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM362.8 346.2C334.3 380.4 292.5 400 248 400S161.7 380.4 133.2 346.2C127.5 339.4 128.5 329.3 135.2 323.7 142 318 152.1 319 157.7 325.7 180.1 352.6 212.9 367.9 247.9 367.9S315.7 352.5 338.1 325.7C343.8 318.9 353.8 318 360.6 323.7 367.5 329.4 368.4 339.5 362.8 346.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smile.js
// module id = sBzW
// module chunks = 0